//AUTHENTICATION
export const GET_LOGIN_REQUEST = "GET_LOGIN_REQUEST";
export const GET_LOGIN = "GET_LOGIN";
export const GET_LOGIN_ERROR = "GET_LOGIN_ERROR";
export const REMOVE_LOGIN = "REMOVE_LOGIN";
export const REMOVE_LOGIN_STATUS = "REMOVE_LOGIN_STATUS";
export const UPDATE_OTP_TIME = "UPDATE_OTP_TIME";
export const UPDATE_AUTH_STATUS = "UPDATE_AUTH_STATUS";
export const REMOVE_LOGED_STATUS = "REMOVE_LOGED_STATUS";

// CMS
export const FETCH_CMS_REQUEST = "FETCH_CMS_REQUEST";
export const FETCH_CMS_SUCCESS = "FETCH_CMS_SUCCESS";
export const FETCH_CMS_FAILURE = "FETCH_CMS_FAILURE";

// GET ALL ACCOUNT
export const GET_ALLACCOUNT_REQUEST = "GET_ALLACCOUNT_REQUEST";
export const GET_ALLACCOUNT = "GET_ALLACCOUNT";
export const GET_ALLACCOUNT_ERROR = "GET_ALLACCOUNT_ERROR";
export const UPDATE_ALLACCOUNT_DATA = "UPDATE_ALLACCOUNT_DATA";
export const REMOVE_ALLACCOUNT = "REMOVE_ALLACCOUNT";


// ALL TICKET TYPE
export const GET_TICKETS_REQUEST = "GET_TICKETS_REQUEST";
export const GET_TICKETS = "GET_TICKETS";
export const GET_TICKETS_ERROR = "GET_TICKETS_ERROR";
export const UPDATE_TICKETS_DATA = "UPDATE_TICKETS_DATA";
export const REMOVE_TICKETS_DATA = "REMOVE_TICKETS_DATA";

// GET TICKET TYPE
export const GET_TICKET_TYPE_REQUEST = "GET_TICKET_TYPE_REQUEST";
export const GET_TICKET_TYPE = "GET_TICKET_TYPE";
export const GET_TICKET_TYPE_ERROR = "GET_TICKET_TYPE_ERROR";
export const UPDATE_TICKET_TYPE_DATA = "UPDATE_TICKET_TYPE_DATA";
export const REMOVE_TICKET_TYPE_DATA = "REMOVE_TICKET_TYPE_DATA";

// GET TRANSACTION HISTORY
export const GET_TRANSACTION_HISTORY_REQUEST =
  "GET_TRANSACTION_HISTORY_REQUEST";
export const GET_TRANSACTION_HISTORY = "GET_TRANSACTION_HISTORY";
export const GET_TRANSACTION_HISTORY_ERROR = "GET_TRANSACTION_HISTORY_ERROR";
export const UPDATE_TRANSACTION_HISTORY_DATA =
  "UPDATE_TRANSACTION_HISTORY_DATA";
export const REMOVE_TRANSACTION_HISTORY_DATA =
  "REMOVE_TRANSACTION_HISTORY_DATA";



// GET USER DETAIL
export const GET_USER_DETAIL_REQUEST = "GET_USER_DETAIL_REQUEST";
export const GET_USER_DETAIL = "GET_USER_DETAIL";
export const GET_USER_DETAIL_ERROR = "GET_USER_DETAIL_ERROR";
export const UPDATE_USER_DETAIL_DATA = "UPDATE_USER_DETAIL_DATA";
export const REMOVE_USER_DETAIL_DATA = "REMOVE_USER_DETAIL_DATA";
export const REMOVE_USER_NAME_DATA = "REMOVE_USER_NAME_DATA";

// GET TRADE PAIR DETAIL
export const GET_TRADEPAIR_REQUEST = "GET_TRADEPAIR_REQUEST";
export const GET_TRADEPAIR = "GET_TRADEPAIR";
export const GET_TRADEPAIR_ERROR = "GET_TRADEPAIR_ERROR";
export const UPDATE_TRADEPAIR_DATA = "UPDATE_TRADEPAIR_DATA";
export const UPDATE_SINGLE_TRADEPAIR_DATA = "UPDATE_SINGLE_TRADEPAIR_DATA";
export const REMOVE_TRADEPAIR_DATA = "REMOVE_TRADEPAIR_DATA";

// GET TRADE SETTINGS DETAIL
export const GET_TRADE_SETTINGS_REQUEST = "GET_TRADE_SETTINGS_REQUEST";
export const GET_TRADE_SETTINGS = "GET_TRADE_SETTINGS";
export const GET_TRADE_SETTINGS_ERROR = "GET_TRADE_SETTINGS_ERROR";
export const UPDATE_TRADE_SETTINGS_DATA = "UPDATE_TRADE_SETTINGS_DATA";
export const REMOVE_TRADE_SETTINGS_DATA = "REMOVE_TRADE_SETTINGS_DATA";


// GET USER WALLET
export const GET_USER_WALLET_REQUEST = "GET_USER_WALLET_REQUEST";
export const GET_USER_WALLET = "GET_USER_WALLET";
export const GET_USER_WALLET_ERROR = "GET_USER_WALLET_ERROR";
export const UPDATE_USER_WALLET_DATA = "UPDATE_USER_WALLET_DATA";

// GET user trading terminal
export const FETCH_TERMINAL_OPTIONS_REQUEST = "FETCH_TERMINAL_OPTIONS_REQUEST";
export const FETCH_TERMINAL_OPTIONS_SUCCESS = "FETCH_TERMINAL_OPTIONS_SUCCESS";
export const FETCH_TERMINAL_OPTIONS_FAILURE = "FETCH_TERMINAL_OPTIONS_FAILURE";

export const UPDATE_TERMINAL_REQUEST = "UPDATE_TERMINAL_REQUEST";
export const UPDATE_TERMINAL_SUCCESS = "UPDATE_TERMINAL_SUCCESS";
export const UPDATE_TERMINAL_FAILURE = "UPDATE_TERMINAL_FAILURE";

// notification

export const FETCH_NOTIFICATIONS_REQUEST = "FETCH_NOTIFICATIONS_REQUEST";
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";
export const FETCH_NOTIFICATIONS_FAILURE = "FETCH_NOTIFICATIONS_FAILURE";

export const MARK_AS_READ_SUCCESS = "MARK_AS_READ_SUCCESS";

export const FETCH_NOTIFICATION_COUNTS_SUCCESS =
  "FETCH_NOTIFICATION_COUNTS_SUCCESS";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const REMOVE_NOTIFICATION_DATA = "REMOVE_NOTIFICATION_DATA";
// profile change steps

export const GET_PROFILE_STEPS_REQUEST = "GET_PROFILE_STEPS_REQUEST";
export const GET_PROFILE_STEPS_SUCCESS = "GET_PROFILE_STEPS_SUCCESS";
export const GET_PROFILE_STEPS_FAILURE = "GET_PROFILE_STEPS_FAILURE";

export const VERIFY_EMAIL_OTP_REQUEST = "VERIFY_EMAIL_OTP_REQUEST";
export const VERIFY_EMAIL_OTP_SUCCESS = "VERIFY_EMAIL_OTP_SUCCESS";
export const VERIFY_EMAIL_OTP_FAILURE = "VERIFY_EMAIL_OTP_FAILURE";

//GET OPEN POSITIONS DETAIL
export const GET_OPEN_POSITIONS_REQUEST = "GET_OPEN_POSITIONS_REQUEST";
export const GET_OPEN_POSITIONS = "GET_OPEN_POSITIONS";
export const GET_OPEN_POSITIONS_ERROR = "GET_OPEN_POSITIONS_ERROR";
export const UPDATE_OPEN_POSITIONS_DATA = "UPDATE_OPEN_POSITIONS_DATA";
export const REMOVE_OPEN_POSITIONS_DATA = "REMOVE_OPEN_POSITIONS_DATA";

//GET CLOSED POSITIONS DETAIL
export const GET_CLOSED_POSITIONS_REQUEST = "GET_CLOSED_POSITIONS_REQUEST";
export const GET_CLOSED_POSITIONS = "GET_CLOSED_POSITIONS";
export const GET_CLOSED_POSITIONS_ERROR = "GET_CLOSED_POSITIONS_ERROR";
export const UPDATE_CLOSED_POSITIONS_DATA = "UPDATE_CLOSED_POSITIONS_DATA";
export const REMOVE_CLOSED_POSITIONS_DATA = "REMOVE_CLOSED_POSITIONS_DATA";

//GET PENDING POSITIONS DETAIL
export const GET_PENDING_POSITIONS_REQUEST = "GET_PENDING_POSITIONS_REQUEST";
export const GET_PENDING_POSITIONS = "GET_PENDING_POSITIONS";
export const GET_PENDING_POSITIONS_ERROR = "GET_PENDING_POSITIONS_ERROR";
export const UPDATE_PENDING_POSITIONS_DATA = "UPDATE_PENDING_POSITIONS_DATA";
export const REMOVE_PENDING_POSITIONS_DATA = "REMOVE_PENDING_POSITIONS_DATA";
// sitesetting

export const GET_SITE_SETTINGS_REQUEST = "GET_SITE_SETTINGS_REQUEST";
export const GET_SITE_SETTINGS_SUCCESS = "GET_SITE_SETTINGS_SUCCESS";
export const GET_SITE_SETTINGS_ERROR = "GET_SITE_SETTINGS_ERROR";



// faq
export const FETCH_FAQ_REQUEST = "FETCH_FAQ_REQUEST";
export const FETCH_FAQ_SUCCESS = "FETCH_FAQ_SUCCESS";
export const FETCH_FAQ_FAILURE = "FETCH_FAQ_FAILURE";
//  trade - symbol

export const FETCH_SYMBOLS_REQUEST = "FETCH_SYMBOLS_REQUEST";
export const FETCH_SYMBOLS_SUCCESS = "FETCH_SYMBOLS_SUCCESS";
export const FETCH_SYMBOLS_FAILURE = "FETCH_SYMBOLS_FAILURE";
export const UPDATE_SYMBOLS_DATA = "UPDATE_SYMBOLS_DATA";
export const SET_SYMBOLS = "SET_SYMBOLS";



// sitesetting

// GET ALL ACCOUNT
export const GET_ORDER_HISTORY_REQUEST = "GET_ORDER_HISTORY_REQUEST";
export const GET_ORDER_HISTORY = "GET_ORDER_HISTORY";
export const GET_ORDER_HISTORY_ERROR = "GET_ORDER_HISTORY_ERROR";
export const UPDATE_ORDER_HISTORY_DATA = "UPDATE_ORDER_HISTORY_DATA";
export const REMOVE_ORDER_HISTORY = "REMOVE_ORDER_HISTORY";

// GET ALL SOCIAL TRADING
export const GET_ALL_SOCIAL_TRADING_REQUEST = "GET_ALL_SOCIAL_TRADING_REQUEST";
export const GET_ALL_SOCIAL_TRADING = "GET_ALL_SOCIAL_TRADING";
export const GET_ALL_SOCIAL_TRADING_ERROR = "GET_ALL_SOCIAL_TRADING_ERROR";
export const UPDATE_ALL_SOCIAL_TRADING_DATA = "UPDATE_ALL_SOCIAL_TRADING_DATA";
export const REMOVE_ALL_SOCIAL_TRADING = "REMOVE_ALL_SOCIAL_TRADING";

// GET ALL MARKET VIEW
export const GET_ALL_MARKET_VIEW_REQUEST = "GET_ALL_MARKET_VIEW_REQUEST";
export const GET_ALL_MARKET_VIEW = "GET_ALL_MARKET_VIEW";
export const GET_ALL_MARKET_VIEW_ERROR = "GET_ALL_MARKET_VIEW_ERROR";
export const UPDATE_ALL_MARKET_VIEW_DATA = "UPDATE_ALL_MARKET_VIEW_DATA";
export const REMOVE_ALL_MARKET_VIEW = "REMOVE_ALL_MARKET_VIEW";


// get open and close order -cp
export const GET_CP_TRADE_ORDERS_REQUEST = "GET_CP_TRADE_ORDERS_REQUEST";
export const GET_CP_TRADE_ORDERS_SUCCESS = "GET_CP_TRADE_ORDERS_SUCCESS";
export const GET_CP_TRADE_ORDERS_ERROR = "GET_CP_TRADE_ORDERS_ERROR";

// Provider
export const GET_PROVIDER_STRATEGY_LIST_REQUEST = "GET_PROVIDER_STRATEGY_LIST_REQUEST";
export const GET_PROVIDER_STRATEGY_LIST_SUCCESS = "GET_PROVIDER_STRATEGY_LIST_SUCCESS";
export const GET_PROVIDER_STRATEGY_LIST_FAILURE = "GET_PROVIDER_STRATEGY_LIST_FAILURE";
export const GET_PARTNERCODE = "GET_PARTNERCODE";

// Promotion
export const GET_PROMOTION_LIST_REQUEST = "GET_PROMOTION_LIST_REQUEST"
export const GET_PROMOTION_LIST_SUCCESS = "GET_PROMOTION_LIST_SUCCESS"
export const GET_PROMOTION_LIST_FAILURE = "GET_PROMOTION_LIST_FAILURE"










// GET MY INVESTMENTS
export const GET_MY_INVESTMENT_REQUEST = "GET_MY_INVESTMENT_REQUEST";
export const GET_MY_INVESTMENT = "GET_MY_INVESTMENT";
export const GET_MY_INVESTMENT_ERROR = "GET_MY_INVESTMENT_ERROR";
export const UPDATE_MY_INVESTMENT_DATA = "UPDATE_MY_INVESTMENT_DATA";
export const REMOVE_MY_INVESTMENT = "REMOVE_MY_INVESTMENT";


// GET TRADE SETTINGS DETAIL
export const GET_ASSETS_REQUEST = "GET_ASSETS_REQUEST";
export const GET_ASSETS_SUCCESS = "GET_ASSETS_SUCCESS";
export const GET_ASSETS = "GET_ASSETS";
export const GET_ASSETS_ERROR = "GET_ASSETS_ERROR";
export const UPDATE_ASSETS_DATA = "UPDATE_ASSETS_DATA";
export const REMOVE_ASSETS_DATA = "REMOVE_ASSETS_DATA";



// GET ALL TRADE PAIR LIST
export const GET_ALL_TRADE_PAIR_REQUEST = "GET_ALL_TRADE_PAIR_REQUEST";
export const GET_ALL_TRADE_PAIR = "GET_ALL_TRADE_PAIR";
export const GET_ALL_TRADE_PAIR_ERROR = "GET_ALL_TRADE_PAIR_ERROR";
export const UPDATE_ALL_TRADE_PAIR_DATA = "UPDATE_ALL_TRADE_PAIR_DATA";
export const REMOVE_ALL_TRADE_PAIR = "REMOVE_ALL_TRADE_PAIR";

// GET SPOT TRADEPAIR LIST
export const GET_SPOT_TRADE_PAIR_REQUEST = "GET_SPOT_TRADE_PAIR_REQUEST";
export const GET_SPOT_TRADE_PAIR = "GET_SPOT_TRADE_PAIR";
export const GET_SPOT_TRADE_PAIR_ERROR = "GET_SPOT_TRADE_PAIR_ERROR";
export const UPDATE_SPOT_TRADE_PAIR_DATA = "UPDATE_SPOT_TRADE_PAIR_DATA";
export const REMOVE_SPOT_TRADE_PAIR = "REMOVE_SPOT_TRADE_PAIR";

//GET TOP MARKET LIST
export const GET_TOP_MARKET_LIST_REQUEST = "GET_TOP_MARKET_LIST_REQUEST";
export const GET_TOP_MARKET_LIST = "GET_TOP_MARKET_LIST";
export const GET_TOP_MARKET_ERROR = "GET_TOP_MARKET_ERROR";
export const UPDATE_TOP_MARKET_DATA = "UPDATE_TOP_MARKET_DATA";
export const REMOVE_TOP_MARKET_DATA = "REMOVE_TOP_MARKET_DATA";

// GET ALL TRADE PAIR LIST
export const GET_NEW_TRADE_PAIR_REQUEST = "GET_NEW_TRADE_PAIR_REQUEST";
export const GET_NEW_TRADE_PAIR = "GET_NEW_TRADE_PAIR";
export const GET_NEW_TRADE_PAIR_ERROR = "GET_NEW_TRADE_PAIR_ERROR";
export const UPDATE_NEW_TRADE_PAIR_DATA = "UPDATE_NEW_TRADE_PAIR_DATA";
export const REMOVE_NEW_TRADE_PAIR = "REMOVE_NEW_TRADE_PAIR";

//TRADE PAGE SPOT PAIR
export const GET_STP_REQUEST = "GET_STP_REQUEST";
export const GET_STP = "GET_STP";
export const GET_STP_ERROR = "GET_STP_ERROR";
export const UPDATE_STP_DATA = "UPDATE_STP_DATA";
export const REMOVE_STP = "REMOVE_STP";

export const SELECTED_PAIR_DETAIL = "SELECTED_PAIR_DETAIL"
export const SELECTED_PAIR_PRICE_DETAIL = "SELECTED_PAIR_PRICE_DETAIL"


// GET ALL FAV TRADE PAIR LIST
export const GET_FAV_TRADE_PAIR_REQUEST = "GET_FAV_TRADE_PAIR_REQUEST";
export const GET_FAV_TRADE_PAIR_LIST = "GET_FAV_TRADE_PAIR_LIST";
export const GET_FAV_TRADE_PAIR_ERROR = "GET_FAV_TRADE_PAIR_ERROR";
export const UPDATE_FAV_TRADE_PAIR_DATA = "UPDATE_FAV_TRADE_PAIR_DATA";
export const REMOVE_FAV_TRADE_PAIR_LIST = "REMOVE_FAV_TRADE_PAIR_LIST";



// GET SPOT ORDER BOOK LIST
export const GET_SPOT_ORDER_BOOK_REQUEST = "GET_SPOT_ORDER_BOOK_REQUEST";
export const GET_SPOT_ORDER_BOOK = "GET_SPOT_ORDER_BOOK";
export const GET_SPOT_ORDER_BOOK_ERROR = "GET_SPOT_ORDER_BOOK_ERROR";
export const UPDATE_SPOT_ORDER_BOOK_DATA = "UPDATE_SPOT_ORDER_BOOK_DATA";
export const REMOVE_SPOT_ORDER_BOOK = "REMOVE_SPOT_ORDER_BOOK";




// GET LOGIN HISTORY LIST
export const GET_LOGIN_HISTORY_REQUEST = "GET_LOGIN_HISTORY_REQUEST";
export const GET_LOGIN_HISTORY = "GET_LOGIN_HISTORY";
export const GET_LOGIN_HISTORY_ERROR = "GET_LOGIN_HISTORY_ERROR";
export const UPDATE_LOGIN_HISTORY_DATA = "UPDATE_LOGIN_HISTORY_DATA";
export const REMOVE_LOGIN_HISTORY = "REMOVE_LOGIN_HISTORY";


// GET ALL ASSET LIST
export const GET_ASSETS_LIST_REQUEST = "GET_ASSETS_LIST_REQUEST";
export const GET_ASSETS_LIST = "GET_ASSETS_LIST";
export const GET_ASSETS_LIST_ERROR = "GET_ASSETS_LIST_ERROR";
export const UPDATE_ASSETS_LIST_DATA = "UPDATE_ASSETS_LIST_DATA";
export const REMOVE_ASSETS_LIST = "REMOVE_ASSETS_LIST";



// GET ALL TRADEHISTORY
export const GET_ALL_TRADE_HISTORY_REQUEST = "GET_ALL_TRADE_HISTORY_REQUEST";
export const GET_ALL_TRADE_HISTORY = "GET_ALL_TRADE_HISTORY";
export const GET_ALL_TRADE_HISTORY_ERROR = "GET_ALL_TRADE_HISTORY_ERROR";
export const UPDATE_ALL_TRADE_HISTORY_DATA = "UPDATE_ALL_TRADE_HISTORY_DATA";
export const REMOVE_ALL_TRADE_HISTORY = "REMOVE_ALL_TRADE_HISTORY";

// GET WALLET BALANCE
export const GET_WALLET_BALANCE_REQUEST = "GET_WALLET_BALANCE_REQUEST";
export const GET_WALLET_BALANCE = "GET_WALLET_BALANCE";
export const GET_WALLET_BALANCE_ERROR = "GET_WALLET_BALANCE_ERROR";
export const UPDATE_WALLET_BALANCE_DATA = "UPDATE_WALLET_BALANCE_DATA";
export const REMOVE_WALLET_BALANCE_DATA = "REMOVE_WALLET_BALANCE_DATA";

export const GET_WALLET_SUMMARY_REQUEST = "GET_WALLET_SUMMARY_REQUEST";
export const GET_WALLET_SUMMARY_SUCCESS = "GET_WALLET_SUMMARY_SUCCESS";
export const GET_WALLET_SUMMARY_FAILURE = "GET_WALLET_SUMMARY_FAILURE";




// user transaction 

// TRANSACTION HISTORY
export const GET_TRANSACTION_HISTORY_SUCCESS = "GET_TRANSACTION_HISTORY_SUCCESS";
export const GET_TRANSACTION_HISTORY_FAILURE = "GET_TRANSACTION_HISTORY_FAILURE";
export const RESET_TRANSACTION_HISTORY = "RESET_TRANSACTION_HISTORY";




export const UPDATE_TRANSACTION_DATA = "UPDATE_TRANSACTION_DATA";
export const REMOVE_TRANSACTION_DATA = "REMOVE_TRANSACTION_DATA";


//  trade history 

export const FETCH_TRADE_HISTORY_REQUEST = "FETCH_TRADE_HISTORY_REQUEST";
export const FETCH_TRADE_HISTORY_SUCCESS = "FETCH_TRADE_HISTORY_SUCCESS";
export const FETCH_TRADE_HISTORY_FAILURE = "FETCH_TRADE_HISTORY_FAILURE";


// GET WALLET LIST
export const GET_WALLET_LIST_REQUEST = "GET_WALLET_LIST_REQUEST";
export const GET_WALLET_LIST = "GET_WALLET_LIST";
export const GET_WALLET_LIST_ERROR = "GET_WALLET_LIST_ERROR";
export const UPDATE_WALLET_LIST_DATA = "UPDATE_WALLET_LIST_DATA";
export const REMOVE_WALLET_LIST_DATA = "REMOVE_WALLET_LIST_DATA";


// GET WALLET LIST
export const GET_ADMIN_BANK_LIST_REQUEST = "GET_ADMIN_BANK_LIST_REQUEST";
export const GET_ADMIN_BANK_LIST = "GET_ADMIN_BANK_LIST";
export const GET_ADMIN_BANK_LIST_ERROR = "GET_ADMIN_BANK_LIST_ERROR";
export const UPDATE_ADMIN_BANK_LIST_DATA = "UPDATE_ADMIN_BANK_LIST_DATA";
export const REMOVE_ADMIN_BANK_LIST_DATA = "REMOVE_ADMIN_BANK_LIST_DATA";

